module.exports = __webpack_public_path__ + "img/人脸机 (4).64f9882e.jpg";